
<template>
  <v-app style="background-color:#F8F9F9;">
    <v-container fluid>
      <v-row justify="center" class="d-flex" style="height: 100vh;">
        <v-col md="9" cols="12" class="align-self-center">
              <v-card class="mx-auto pa-0" elevation="6" rounded="lg">
                  <v-row>
                    <v-col md="6" cols="12" class="pa-0 ma-0 login-left-bg">
                        <div class="login-bg-text">
                            <h1 class="text-h6 font-weight-bold text-white" style="font-size: 2.25rem !important"><span style="font-size: 2rem;">Welcome to</span> <br> HICC - <span style="color: #921a1d">SRC</span> CMS</h1>
                            <p class="text-caption text-white">Please login to continue</p>
                        </div>
                    </v-col>

                    <v-col md="6" cols="12" class="pa-8">
                      <v-form @submit.prevent="submit">
                          <div class="text-center">
                            <img src="@/assets/image/logo.png" class="logo" style="height:80px"/>
                          </div>
                          <v-card-text style="font-weight:600;padding-bottom: 0;padding-top:0px;letter-spacing: 4px;" class="text-center text-h4 ps-0">SWTPPP-III</v-card-text>
                          <p style="font-weight:600;color: rgb(10 180 190)" class="text-center p-0">Component-3.2</p>
                          <v-card-text v-if="errorMessages" class="text-center text-body-2 text-red" style="height:10px">{{ errorMessages }}</v-card-text>
                          <v-card-text class="text-left text-h6 ps-0">Login</v-card-text>
                          <v-text-field
                              density="compact"
                              single-line
                              variant="outlined"
                              bg-color="grey-lighten-4"
                              prepend-inner-icon="mdi mdi-account-outline"
                              v-model="username.value.value"
                              :error-messages="username.errorMessage.value"
                              label="Username"
                              
                          ></v-text-field>

                          <v-text-field
                              :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                              :type="visible ? 'text' : 'password'"
                              density="compact"
                              variant="outlined"
                              bg-color="grey-lighten-4"
                              single-line
                              hide-details="auto"
                              prepend-inner-icon="mdi-lock-outline"
                              @click:append-inner="visible = !visible"
                              v-model="password.value.value"
                              :error-messages="password.errorMessage.value"
                              label="Password"
                          ></v-text-field>
                          <!-- <v-card-text class="text-right text-body-2 pa-0 pt-2"> <a href="" class="text-decoration-none">Forgot Password ?</a></v-card-text> -->
                          
                          <v-btn                    
                              single-line
                              block
                              class="text-none  mt-4"
                              color="indigo-darken-3"
                              size="large"
                              variant="flat"
                              type="submit"               
                              :loading="loading"                 
                              >
                              Login
                          </v-btn>
                      </v-form>

                      <v-footer class="mt-4 mb-0 pb-0">
                          <v-card-text class="text-center px-0 pb-0">Developed By: <a href="https://www.datascapeit.com/" target="_blank">Datascape IT Limited</a></v-card-text>
                      </v-footer>
                    </v-col>
                  </v-row>
              </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { useRouter, useRoute } from 'vue-router';
import { ref } from 'vue';


export default {
  name: 'MyComponent',
  data: () => ({
    loading: false,
    visible: false,
    errorMessages: '',
  }),

  setup() {
    const { handleSubmit } = useForm({
      validationSchema: yup.object({
        username: yup.string().min(3).max(30).required().trim().test('no-spaces', 'Spaces are not allowed', (value) => !/\s/.test(value)).label('Username'),
        password: yup.string()
            .required('Password is required'),
            /* .matches(
              /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{6,30}$/,
              'Password must contain letters and numbers (special characters optional) and be 6 to 30 characters long'
            ).trim().test('no-spaces', 'Spaces are not allowed', (value) => !/\s/.test(value)), */
      }),

    });

    const username = useField('username');
    const password = useField('password');
    const loading = ref(false);
    const errorMessages  = ref('');
    const store = useStore(); 
    const router = useRouter();
    const route = useRoute()
    const submit = handleSubmit((values) => {
        loading.value = true;
        store.dispatch("loginRequest", values)
            .then((response) => {
              const redirectPath = route.query.redirect || "/home/dashboard";
              router.push(redirectPath);
            })
            .catch((error) => {     
              errorMessages.value = 'Username or Password Incorrect';             
            })
            .then((always) => {
              loading.value = false;
            });
    });

    return {
      username,
      password,
      submit,
      loading,
      errorMessages
    };
  },
  methods: {
  },
  mounted() {
    // this.username.value.value = '';
    // this.password.value.value = '';
  }
};
</script>